import { Component, OnInit, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CommunicationService } from '../../../common/services/Communication.service';
import { environment } from '../../../../environments/environment';

import { browserRefresh } from '../../home/home.component';
import { dataModel, PremiumIndustry } from '../../../models/data.model';

@Injectable({
  providedIn: 'root'
})

// tslint:disable: no-string-literal
// tslint:disable: prefer-for-of
// tslint:disable: prefer-const

@Component({
  selector: 'app-account-industries',
  templateUrl: './account-industries.component.html',
  styleUrls: ['./account-industries.component.sass']
})

export class AccountIndustriesComponent implements OnInit  {
  data: dataModel;
  id: string;
  assets: string;
  isClicked = 6;
  totalCaseStudies = 0;
  currentCaseStudies: PremiumIndustry;
  public browserRefresh: boolean;

  constructor(
    private router: Router,
    communicationService: CommunicationService) {
      this.assets = environment.assetsURL;
      this.data = communicationService.data;
      this.id = this.router.url.replace('/industries/', '');
   }


  ngOnInit() {
    this.browserRefresh = browserRefresh;
    this.data.PremiumIndustries.forEach(element => {
      if ( element.router === this.id ) {
        this.totalCaseStudies = element['data'].length;
        this.currentCaseStudies = element;
      }
    });
  }

  caseStudy(id: number) {
    this.data.PremiumIndustries.forEach(element => {
      if ( element.router === this.id ) {
        this.getCurrentClickedCaseStudy(element['data'], id, element.router);
      }
    });
  }

  getCurrentClickedCaseStudy(data: Array<any>, id: number, elRouter: string) {
    for (let i = 0; i < data.length; i++ ) {
      if (data[i].Id === id) {
        let newRoute = data[i].CompanyName.replace(/[^A-Z0-9]/ig, '-').toLowerCase();
        if (!data[i].router) {
            this.router.navigate([`/industries/${this.id}` + '/' + newRoute]);
          } else {
            this.router.navigate([`/industries/${this.id}` + '/' + data[i].router]);
          }
      }
    }
  }

  onLoad() {
    this.isClicked += 6;
  }

  bindStyle(i) {
    let dNone = {display: 'none'};
    let dBlock = {display: 'block'};

    if (this.isClicked <= i) {
      return dNone;
    } else {
      return dBlock;
    }
  }

  hideIfNoMore() {
   let dNone = {display: 'none'};
   if (this.isClicked  >= this.totalCaseStudies) {
    return dNone;
    }
  }
}
